import schoolAxiosInstance from "@quest/school-axios";
import { BaseGetRequestParams, BaseGetRequestResponse } from "@quest/types";
import {
  IAnnouncement,
  IReminderResponse,
  ICreateAnnouncement,
  ICreateReminder,
  IGetAnnouncementsParams,
  IAnnouncementDetails,
} from "../types";

class AnnouncementsService {
  private api = schoolAxiosInstance;
  async getAnnouncements(params: IGetAnnouncementsParams) {
    const response = await this.api.get<BaseGetRequestResponse<IAnnouncement>>(
      "/users/announcement",
      {
        params,
      }
    );
    return response.data;
  }

  async createAnnouncement(data: ICreateAnnouncement) {
    const response = await this.api.post("/users/announcement", data);
    return response.data;
  }

  async getAnnouncementDetails(id: number) {
    const response = await this.api.get<IAnnouncementDetails>(
      `/users/announcement/${id}`
    );
    return response.data;
  }

  async publishAnnouncement(id: number) {
    const response = await this.api.post(`/users/announcement/publish/${id}`);
    return response.data;
  }

  async updateAnnouncement(data: ICreateAnnouncement, id: number) {
    const response = await this.api.put(`/users/announcement/${id}`, data);
    return response.data;
  }

  async deleteAnnouncement(id: number) {
    const response = await this.api.delete(`/users/announcement/${id}`);
    return response.data;
  }

  async getNotificationsByUser(params: BaseGetRequestParams, locale: string) {
    const response = await this.api.get(`/notifications/notification/all`, {
      params,
      headers: {
        "Accept-Language": locale,
      },
    });
    return response.data;
  }

  async markAllNotificationsAsRead() {
    const response = await this.api.put(
      `/notifications/notification/mark-all-as-read`
    );
    return response.data;
  }

  async markNotificationAsRead(id: number) {
    const response = await this.api.put(
      `/notifications/notification/mark-as-read/${id}`
    );
    return response.data;
  }

  async getNotificationDetails(id: number) {
    const response = await this.api.get(
      `/notifications/notification/${id}/announcement`
    );
    return response.data;
  }

  async getReminderNotificationDetails(id: number) {
    const response = await this.api.get(
      `/notifications/notification/${id}/reminder`
    );
    return response.data;
  }

  async createReminder(data: ICreateReminder) {
    const response = await this.api.post("/notifications/reminder", data);
    return response.data;
  }

  async getReminder(params: BaseGetRequestParams) {
    const response = await this.api.get<BaseGetRequestResponse<IAnnouncement>>(
      "/notifications/reminder",
      {
        params,
      }
    );
    return response.data;
  }

  async getReminderDetails(id: number) {
    const response = await this.api.get<IReminderResponse>(
      `/notifications/reminder/${id}`
    );
    return response.data;
  }

  async deleteReminder(id: number) {
    const response = await this.api.delete(`/notifications/reminder/${id}`);
    return response.data;
  }

  async updateReminder(data: ICreateReminder, id: number) {
    const response = await this.api.put(`/notifications/reminder/${id}`, data);
    return response.data;
  }
}

export default new AnnouncementsService();
